import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  CHECK_USER_LOCATION,
  CHECK_DARWIN_ATTENDANCE,
  SUBMIT_DARWIN_ATTENDANCE,
} from './type';

export const checkUserLocation = (latitude, longitude) => async (dispatch) => {
  dispatch({
    type: CHECK_USER_LOCATION,
    payload: null,
  });

  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.attendance.checkUserLocation}?latitude=${latitude}&longitude=${longitude}`
  );

  if (res?.data?.status === 0) {
    dispatch({
      type: CHECK_USER_LOCATION,
      payload: res.data.data,
    });
    return res.data;
  }

  return res;
};

export const checkDarwinAttendance = () => async (dispatch) => {
  dispatch({
    type: CHECK_DARWIN_ATTENDANCE,
    payload: null,
  });

  const res = await callWebService(
    callTypes.get,
    '',
    Config.attendance.checkAttendance
  );

  if (res?.data?.status === 0) {
    dispatch({
      type: CHECK_DARWIN_ATTENDANCE,
      payload: res.data.data,
    });
    return res.data;
  }

  return res;
};

export const submitDarwinAttendance = (payload) => async (dispatch) => {
  dispatch({
    type: SUBMIT_DARWIN_ATTENDANCE,
    payload: null,
  });

  const res = await callWebService(
    callTypes.post,
    payload,
    Config.attendance.markDarwinAttendance
  );

  if (res?.data?.status === 0) {
    dispatch({
      type: SUBMIT_DARWIN_ATTENDANCE,
      payload: res.data.data,
    });
    return res.data;
  }

  return res;
};
